// function gio(...args){
//   if(window.gio){
//     window.gio(...args)
//   }
// }
/**
 * @description 神策埋点
 * @param {String} eventName 事件英文变量名
 * @param {Object} params 对象不能为空
 * @param {function} callBack 成功回调函数
 * @example statistics('PayResult', {is_success: true})
 */
const statistics = (eventName, params, callBack) => {
  if (!eventName) {
    return new Error('eventName: 事件英文变量名不能为空')
  }
  // gio('track', eventName, params)
  typeof callBack === 'function' && callBack()
}
// sensors.registerPage({
//   platform_type: "H5",
//   platform_name: "H5"
// })
// sensors.quick('autoTrack') //用于采集 $pageview 事件。
export const sensorsLogin = (id) => {
  if (!id) {
    console.error(new Error('商户编码为空'))
  }
  // gio('setUserId', id)
}

export const sensorVisitorSet = (data) => {
  if (!data) {
    console.error(new Error('访问用户变量数据为空'))
  }
  // gio('visitor.set', data)
}
export const sensorPeopleSet = (data) => {
  // gio('people.set', data)
}

export const sensorsLoginOut = () => {
  // gio('clearUserId')
}
export const autoTrackSinglePage = (obj) => {
  // gio('page.set', obj)
}

export default statistics



// WEBPACK FOOTER //
// ./src/util/sensors.js